import axios from "axios"

const AxiosClient = axios.create({
    baseURL: `https://api.anbar-bcs.org/Judge` ,
}) ; 

AxiosClient.interceptors.request.use( (config)=>{
    const token = localStorage.getItem('Admin_ACCESS_TOKEN') ;   
    config.headers.Authorization = `Bearer ${token}` ; 
    return config ;  
})
AxiosClient.interceptors.response.use( (res) =>{
return res ; 
} , 
(error )=>{ 
const {response } = error; 


if (response.status ==401) {
        localStorage.removeItem('Admin_ACCESS_TOKEN') ; 
        

        
}
else console.log(response);
throw error ; 
 } )
export default AxiosClient ; 
